import axios from "axios";
import { rootUrl } from "lib/api";
import { getToken, requestHeaders } from "lib/authHelpers";
import { dispatchHelper } from "lib/actionHelpers";

import { authLogoutAndRedirect } from "screens/users/actions";
import { CREATING_TODO, CREATING_TODO_COMMENT } from "./types";

export const createTodo = (params, callback = () => {}) => async (dispatch) => {
  const dispatching = dispatchHelper(CREATING_TODO);
  const token = getToken();
  const url = `${rootUrl}/todos/new`;
  const headers = requestHeaders(token);

  try {
    const response = await axios.post(url, params, headers);
    dispatching(response, callback.bind(this, response.data));
  } catch (err) {
    dispatch(authLogoutAndRedirect());
  }
};

export const createTodoComment = (
  todoId,
  params,
  callback = () => {}
) => async (dispatch) => {
  const dispatching = dispatchHelper(CREATING_TODO_COMMENT);
  const token = getToken();
  const url = `${rootUrl}/todos/${todoId}/comment`;
  const headers = requestHeaders(token);

  try {
    const response = await axios.post(url, params, headers);
    dispatching(response, callback.bind(this, response.data));
  } catch (err) {
    dispatch(authLogoutAndRedirect());
  }
};
